import { Helmet } from "react-helmet";
import SelectPackage from "../components/AiHomePage/SelectPackage";
import BannerSection from "../components/YouTubeThumbnailHome/BannerSection";
import AboutSection from "../components/YouTubeThumbnailHome/AboutSection";
import FeaturesSection from "../components/YouTubeThumbnailHome/FeaturesSection";
import TestimonialSection from "../components/YouTubeThumbnailHome/TestimonialSection";

const Home = () => {
  return (
    <main>
      <Helmet>
        <title>
          Generate e-Commerce Product Details – AI Product Description Generator
        </title>
        <meta
          name="description"
          content="Create compelling, SEO-optimized product descriptions, titles, and bullet points in seconds with our AI-powered product detail generator for e-commerce stores."
        />
        <meta
          name="keywords"
          content="AI product description generator, e-commerce product detail generator, SEO product titles, AI bullet points, AI content for online stores"
        />
      </Helmet>

      <BannerSection />
      <AboutSection />
      <FeaturesSection />
      <SelectPackage />
      <TestimonialSection />
    
    </main>
  );
};

export default Home;
